module.exports = __webpack_public_path__ + "static/media/skype.1d56bf95.png";